import { Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { ProductList } from './ProductList';
import { useProducts } from './useProducts';

export function Products() {
	const { data, selected, goBack, handleSubmit, setSelected, t } = useProducts();
	return (
		<ProgressBar page="products">
			<Typography TagName="h3" className="mb-5">
				{t('sidebar_title', 'products')}
			</Typography>
			<div className="row">
				<div className="col-12 mb-2">
					<p>{t('sidebar_main', 'products')}</p>
					{data && (
						<form>
							<ProductList products={data.generalProducts} selected={selected} setSelected={setSelected} />
							{((data.hasInternalCreditCheck && data.isElidgableForDerivatives) || !data.hasInternalCreditCheck) && (
								<ProductList
									disabled={false === data.isElidgableForDerivatives}
									products={data.derivativeProducts}
									selected={selected}
									setSelected={setSelected}
								/>
							)}
							{data.hasInternalCreditCheck && !data.isElidgableForDerivatives && (
								<span>{t('has_internal_credit_check_but_is_not_eligible_for_derivatives', 'products')}</span>
							)}
							{!data.generalProducts.length && !data.derivativeProducts.length && (
								<span>{t('no_products', 'products')}</span>
							)}
						</form>
					)}
				</div>
			</div>
			<Footer
				handleNext={handleSubmit}
				handlePrev={goBack}
				isDisabled={!selected.length}
				next={t('continue')}
				prev={t('back')}
			/>
		</ProgressBar>
	);
}
